import { CommonSectionIds } from '../common.models';

export const UnknownSectionIds = {
    BasicInfo: CommonSectionIds.BasicInfo,
    DialogActions: CommonSectionIds.DialogActions,
};
